module.exports = __webpack_public_path__ + "media/images/emblems/Urtenen-coat_of_arms-95f561e33a473d7eefec37c9a3b2e2cf.svg";